import {createRouter, createWebHistory} from 'vue-router'
import TodoListView from '../views/TodoListView.vue'
import SearchView from '../views/SearchView.vue'
import TaskDeepLinkView from '../views/TaskDeepLinkView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {path: '/', redirect: '/inbox'},
    {
      path: '/task/:taskId',
      name: 'task-deeplink',
      component: TaskDeepLinkView,
      props: true,
    },
    {
      path: '/agenda',
      name: 'agenda',
      component: TodoListView,
      props: {agenda: true},
    },
    {
      path: '/project/:projectId',
      name: 'todo-project',
      component: TodoListView,
      props: true,
    },
    {
      path: '/focus',
      name: 'focus',
      component: TodoListView,
      props: {focus: true},
    },
    {
      path: '/:folder',
      name: 'todo',
      component: TodoListView,
      props: true,
    },
    {
      path: '/search',
      name: 'search',
      component: SearchView,
    },
  ],
})

export default router
